import React, { useState, useEffect, useRef } from 'react';
import DataTableLayout from '../../../../utility/table/DataTableLayout.jsx'
import CommonComponent from "../../CommonComponent"
import { ordersTableData } from '../../Common/Datatable';


const Orders = ()=> {
  const { tableId, ajaxUrl, columns } = ordersTableData;
  return (
    <>
      <CommonComponent />
      <section className="section dashboard py-2">
        <DataTableLayout tableId={tableId} ajaxUrl={ajaxUrl} columns={columns} />
      </section>
    </>
  );
}


export default Orders;